module.exports = __webpack_public_path__ + "assets/c10611be2538a1849ed1a7addfb942a7.ttf";